'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./address.css');

var _base = require('../_base');

var _base2 = _interopRequireDefault(_base);

var _ = require('../../../../');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// https://github.com/JedWatson/react-select

var GeckoFieldAddress = function (_GeckoFieldBase) {
    _inherits(GeckoFieldAddress, _GeckoFieldBase);

    function GeckoFieldAddress() {
        var _ref, _ref2, _ref3, _ref4, _ref5;

        var _temp, _this, _ret;

        _classCallCheck(this, GeckoFieldAddress);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeckoFieldAddress.__proto__ || Object.getPrototypeOf(GeckoFieldAddress)).call.apply(_ref, [this].concat(args))), _this), _this.inputs = [{
            label: 'Street Address',
            key: 'street_address',
            autocomplete: 'address-line1'
        }, {
            label: 'Address Line 2',
            key: 'address_line_2',
            autocomplete: 'address-line2'
        }, (_ref2 = {
            label: 'City',
            key: 'city'
        }, _defineProperty(_ref2, 'class', 'half'), _defineProperty(_ref2, 'autocomplete', 'address-level2'), _ref2), (_ref3 = {
            label: 'Region / State',
            key: 'state'
        }, _defineProperty(_ref3, 'class', 'half'), _defineProperty(_ref3, 'autocomplete', 'address-level1'), _ref3), (_ref4 = {
            label: 'Post Code / Zip Code',
            key: 'postal_code'
        }, _defineProperty(_ref4, 'class', 'half'), _defineProperty(_ref4, 'autocomplete', 'postal-code'), _ref4), (_ref5 = {
            label: 'Country',
            key: 'country'
        }, _defineProperty(_ref5, 'class', 'half'), _defineProperty(_ref5, 'type', _.GECKO_CONSTS.FIELD_TYPE_SELECT), _defineProperty(_ref5, 'autocomplete', 'country'), _ref5)], _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(GeckoFieldAddress, [{
        key: 'renderInputId',
        value: function renderInputId(input) {
            return this.renderId() + '_' + input.key;
        }
    }, {
        key: 'renderTextInput',
        value: function renderTextInput(input) {
            return _react2.default.createElement('input', Object.assign({
                id: this.renderInputId(input),
                placeholder: input.label,
                autoComplete: input.autocomplete,
                className: 'col-sm form-control gecko-ui-material',
                type: 'text',
                disabled: this.isDisabled(),
                value: this.jsonValue()[input.key],
                onChange: this.handleChange.bind(this, input),
                required: this.isRequired(),
                'aria-required': this.isRequired()
            }, this.renderAriaAttrs()));
        }
    }, {
        key: 'renderSelectInput',
        value: function renderSelectInput(input) {
            var value = this.jsonValue()[input.key];
            var selectedOption = this.options().find(function (o) {
                return o.value === value;
            }) || null;

            return _react2.default.createElement(_reactSelect2.default, {
                id: this.renderInputId(input),
                classNamePrefix: 'Select',
                className: 'Select gecko-ui-material',
                options: this.options(),
                isDisabled: this.isDisabled(),
                value: selectedOption ? selectedOption : null,
                onChange: this.handleChange.bind(this, input),
                placeholder: input.label });
        }
    }, {
        key: 'buildInput',
        value: function buildInput(input, i) {
            return _react2.default.createElement(
                'div',
                { className: input.class, key: i },
                _react2.default.createElement(
                    'label',
                    { htmlFor: this.renderInputId(input) },
                    input.label
                ),
                input.type === _.GECKO_CONSTS.FIELD_TYPE_SELECT ? this.renderSelectInput(input) : this.renderTextInput(input)
            );
        }
    }, {
        key: 'handleChange',
        value: function handleChange(input, event) {
            var value = void 0;

            if (input.type === _.GECKO_CONSTS.FIELD_TYPE_SELECT) {
                if (event && event.value) {
                    value = event.value;
                } else {
                    value = null;
                }
            } else {
                value = event.target.value;
            }

            return this.props.handler.bind(this, this.field().key, this.prepareJsonValue(input.key, value))();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'row' },
                this.inputs.map(function (input, i) {
                    return _this2.buildInput(input, i);
                })
            );
        }
    }]);

    return GeckoFieldAddress;
}(_base2.default);

exports.default = GeckoFieldAddress;